import { AlertTriangle, Building2, Clock, ExternalLink, Home, Settings } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const RMCVacancy = () => {
  console.log('🚀 RMCVacancy 컴포넌트 마운트됨');
  
  const [activeTab, setActiveTab] = useState('dashboard');
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedPropertyOwner, setSelectedPropertyOwner] = useState('');
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [propertyOwners, setPropertyOwners] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [partners, setPartners] = useState([]);
  
  // 데이터 상태 추가
  const [dashboardData, setDashboardData] = useState(null);
  const [vacantUnits, setVacantUnits] = useState([]);
  const [expiringUnits, setExpiringUnits] = useState([]);
  const [messageHistory, setMessageHistory] = useState([]);
  
  // 중개요청 관련 상태
  const [showBrokerageModal, setShowBrokerageModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [brokerageForm, setBrokerageForm] = useState({
    request_type: 'rental',
    priority: 'normal',
    description: '',
    expected_rent: '',
    expected_deposit: '',
    contact_person: '',
    contact_phone: '',
    notes: ''
  });
  
  // 메시지 발송 관련 상태
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageForm, setMessageForm] = useState({
    message_type: 'email',
    subject: '',
    content: '',
    recipient_email: '',
    recipient_phone: '',
    partner_ids: []
  });
  
  // 상세보기 모달 관련 상태
  const [showDetailModal, setShowDetailModal] = useState(false);
  
  // 메시지 템플릿 관련 상태
  const [messageTemplates, setMessageTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  
  const [loading, setLoading] = useState(false);

  const tabs = [
    { id: 'dashboard', label: '대시보드' },
    { id: 'vacant', label: '공실현황' },
    { id: 'expiring', label: '만기예정' },
    { id: 'history', label: '중개요청내역' }
  ];

  useEffect(() => {
    console.log('🔄 useEffect 실행: loadCurrentUser 호출');
    loadCurrentUser();
    loadMessageTemplates();
    loadPartners();
  }, []);

  // currentUser가 로드된 후 임대사업자 목록 로드
  useEffect(() => {
    if (currentUser) {
      console.log('🔄 currentUser 로드됨, 임대사업자 목록 로드 시작');
      loadPropertyOwners();
    }
  }, [currentUser]);

  useEffect(() => {
    const isRMCUser = currentUser?.role === 'rental_management_company' || 
                      currentUser?.role === 'rmc_admin' || 
                      currentUser?.role === 'rmc_staff';
    
    if (selectedPropertyOwner && isRMCUser) {
      loadBuildings();
    }
  }, [selectedPropertyOwner, currentUser]);

  useEffect(() => {
    console.log('🔄 데이터 로드 useEffect 실행:', { currentUser, selectedPropertyOwner, selectedBuilding });
    if (currentUser) {
      console.log('✅ currentUser 있음, 데이터 로드 시작');
      loadBuildings(); // 건물 목록 로드 추가
      loadDashboardData();
      loadVacantUnits();
      loadExpiringUnits();
    } else {
      console.log('❌ currentUser 없음');
    }
  }, [selectedPropertyOwner, selectedBuilding, currentUser]);

  const loadCurrentUser = async () => {
    try {
      console.log('🔍 사용자 정보 로드 시작');
      const response = await api.get('/auth/me');
      console.log('✅ 사용자 정보:', response);
      setCurrentUser(response);
    } catch (error) {
      console.error('❌ 사용자 정보 로드 실패:', error);
    }
  };

  const loadPropertyOwners = async () => {
    try {
      console.log('🔍 임대사업자 목록 로드 시작');
      console.log('🔍 currentUser:', currentUser);
      
      if (!currentUser) {
        console.log('⚠️ currentUser가 없어서 임대사업자 목록 로드를 건너뜀');
        return;
      }
      
      // RMC 사용자는 RMC 전용 API 사용
      const isRMCUser = currentUser?.role === 'rental_management_company' || 
                        currentUser?.role === 'rmc_admin' || 
                        currentUser?.role === 'rmc_staff';
      
      console.log('🔍 isRMCUser:', isRMCUser);
      
      const apiUrl = isRMCUser ? '/rmc/property-owners' : '/property-owners';
      console.log('🔍 사용할 API URL:', apiUrl);
      
      const response = await api.get(apiUrl);
      console.log('✅ 임대사업자 목록:', response);
      console.log('✅ 응답 타입:', typeof response);
      console.log('✅ 배열 여부:', Array.isArray(response));
      
      if (Array.isArray(response)) {
        setPropertyOwners(response);
        console.log('✅ 임대사업자 목록 설정 완료:', response.length, '개');
      } else {
        console.log('⚠️ 응답이 배열이 아닙니다:', response);
        setPropertyOwners([]);
      }
    } catch (error) {
      console.error('❌ 임대사업자 목록 로드 실패:', error);
      setPropertyOwners([]);
    }
  };

  const loadBuildings = async () => {
    try {
      const isRMCUser = currentUser?.role === 'rental_management_company' || 
                        currentUser?.role === 'rmc_admin' || 
                        currentUser?.role === 'rmc_staff';
      
      if (isRMCUser) {
        // RMC 사용자는 선택된 임대사업자의 건물
        const url = selectedPropertyOwner 
          ? `/buildings?property_owner_id=${selectedPropertyOwner}`
          : '/buildings';
        const response = await api.get(url);
        setBuildings(response);
      } else {
        // 임대사업자 사용자는 자신의 건물
        const response = await api.get('/buildings');
        setBuildings(response);
      }
    } catch (error) {
      console.error('건물 목록 로드 실패:', error);
    }
  };

  const loadDashboardData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/dashboard?${params.toString()}` : '/vacancy/dashboard';
      console.log('🔍 대시보드 API 호출:', url);
      const response = await api.get(url);
      console.log('✅ 대시보드 API 응답:', response);
      setDashboardData(response.data);
    } catch (error) {
      console.error('❌ 대시보드 데이터 로드 실패:', error);
      console.error('오류 상세:', error.response?.data || error.message);
      setDashboardData({
        total_buildings: 0,
        total_units: 0,
        vacant_units: 0,
        expiring_contracts: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const loadVacantUnits = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/vacant-units?${params.toString()}` : '/vacancy/vacant-units';
      console.log('🔍 공실 목록 API 호출:', url);
      const response = await api.get(url);
      console.log('✅ 공실 목록 API 응답:', response);
      console.log('🔍 응답 데이터 구조:', {
        isArray: Array.isArray(response),
        hasData: !!response?.data,
        hasVacantUnits: !!response?.vacant_units,
        firstUnit: response?.data?.[0] || response?.[0] || response?.vacant_units?.[0]
      });
      
      // 응답 데이터 안전하게 처리
      const units = Array.isArray(response) ? response : 
                   Array.isArray(response?.data) ? response.data : 
                   Array.isArray(response?.vacant_units) ? response.vacant_units : [];
      setVacantUnits(units);
    } catch (error) {
      console.error('❌ 공실 목록 로드 실패:', error);
      console.error('오류 상세:', error.response?.data || error.message);
      setVacantUnits([]);
    }
  };

  const loadExpiringUnits = async () => {
    try {
      const params = new URLSearchParams();
      if (selectedPropertyOwner) {
        params.append('property_owner_id', selectedPropertyOwner);
      }
      if (selectedBuilding) {
        params.append('building_id', selectedBuilding);
      }
      const url = params.toString() ? `/vacancy/expiring-units?${params.toString()}` : '/vacancy/expiring-units';
      console.log('🔍 만기예정 목록 API 호출:', url);
      const response = await api.get(url);
      console.log('✅ 만기예정 목록 API 응답:', response);
      
      // 응답 데이터 안전하게 처리
      const units = Array.isArray(response) ? response : 
                   Array.isArray(response?.data) ? response.data : 
                   Array.isArray(response?.expiring_units) ? response.expiring_units : [];
      setExpiringUnits(units);
    } catch (error) {
      console.error('❌ 만기예정 목록 로드 실패:', error);
      console.error('오류 상세:', error.response?.data || error.message);
      setExpiringUnits([]);
    }
  };

  const handlePropertyOwnerChange = (propertyOwnerId) => {
    setSelectedPropertyOwner(propertyOwnerId);
    setSelectedBuilding(''); // 건물 선택 초기화
  };

  // 메시지 템플릿 로드
  const loadMessageTemplates = async () => {
    try {
      const response = await api.get('/message-templates');
      if (response.success) {
        setMessageTemplates(response.data);
      }
    } catch (error) {
      console.error('메시지 템플릿 로드 실패:', error);
    }
  };

  // 상세보기 처리

  const loadPartners = async () => {
    try {
      const response = await api.get('/partners');
      const list = Array.isArray(response?.data) ? response.data : [];
      setPartners(list);
    } catch (error) {
      console.error('파트너 목록 로드 실패:', error);
      setPartners([]);
    }
  };

  const togglePartnerSelection = (partnerId) => {
    setMessageForm(prev => {
      const selected = prev.partner_ids || [];
      const next = selected.includes(partnerId)
        ? selected.filter(id => id !== partnerId)
        : [...selected, partnerId];
      return { ...prev, partner_ids: next };
    });
  };

  const handleViewDetails = (unit) => {
    setSelectedUnit(unit);
    setShowDetailModal(true);
  };

  // 계약연장확인요청 처리
  const handleContractRenewalInquiry = (unit) => {
    setSelectedUnit(unit);
    const monthlyRent = unit.standard_monthly_rent ? `${unit.standard_monthly_rent.toLocaleString()}원` : '미정';
    const deposit = unit.standard_deposit ? `${unit.standard_deposit.toLocaleString()}원` : '미정';
    const maintenanceFee = unit.standard_maintenance_fee ? `${unit.standard_maintenance_fee.toLocaleString()}원` : '미정';
    
    setMessageForm({
      message_type: 'email',
      subject: `[계약연장 문의] ${unit.building_name} ${unit.unit_number}호`,
      content: `안녕하세요.\n\n${unit.building_name} ${unit.unit_number}호 계약이 곧 만료 예정입니다.\n\n■ 세대 정보\n- 건물: ${unit.building_name}\n- 세대: ${unit.unit_number}호\n- 면적: ${unit.area || '-'}㎡\n- 기준월세: ${monthlyRent}\n- 기준보증금: ${deposit}\n- 기준관리비: ${maintenanceFee}\n\n계약 연장에 대한 의향을 알려주시기 바랍니다.\n\n감사합니다.`,
      recipient_email: '',
      recipient_phone: '',
      partner_ids: []
    });
    setShowMessageModal(true);
  };

  // 메시지 발송 처리
  const handleSendMessage = (unit) => {
    setSelectedUnit(unit);
    const monthlyRent = unit.standard_monthly_rent ? `${unit.standard_monthly_rent.toLocaleString()}원` : '미정';
    const deposit = unit.standard_deposit ? `${unit.standard_deposit.toLocaleString()}원` : '미정';
    const maintenanceFee = unit.standard_maintenance_fee ? `${unit.standard_maintenance_fee.toLocaleString()}원` : '미정';
    
    setMessageForm({
      message_type: 'email',
      subject: `[공실안내] ${unit.building_name} ${unit.unit_number}호`,
      content: `안녕하세요.\n\n${unit.building_name} ${unit.unit_number}호가 현재 공실 상태입니다.\n\n■ 세대 정보\n- 건물: ${unit.building_name}\n- 세대: ${unit.unit_number}호\n- 면적: ${unit.area || '-'}㎡\n- 기준월세: ${monthlyRent}\n- 기준보증금: ${deposit}\n- 기준관리비: ${maintenanceFee}\n\n임대 문의가 있으시면 연락주시기 바랍니다.\n\n감사합니다.`,
      recipient_email: '',
      recipient_phone: '',
      partner_ids: []
    });
    setShowMessageModal(true);
  };

  // 중개요청 처리
  const handleBrokerageRequest = (unit) => {
    setSelectedUnit(unit);
    setShowBrokerageModal(true);
  };

  // 메시지 템플릿 선택 처리
  const handleTemplateSelect = (templateId) => {
    const template = messageTemplates.find(t => t.id === templateId);
    if (template) {
      setSelectedTemplate(templateId);
      setMessageForm(prev => ({
        ...prev,
        subject: template.subject || prev.subject,
        content: template.content || prev.content
      }));
    }
  };

  // 메시지 발송 실행
  const sendMessage = async () => {
    if (!selectedUnit) return;
    
    try {
      setLoading(true);
      const response = await api.post('/vacancy/send-messages', {
        unit_ids: [selectedUnit.unit_id || selectedUnit.id],
        message_type: messageForm.message_type,
        subject: messageForm.subject,
        content: messageForm.content,
        recipient_email: messageForm.recipient_email,
        recipient_phone: messageForm.recipient_phone,
        partner_ids: messageForm.partner_ids || [],
        template_id: selectedTemplate
      });
      
      if (response.success) {
        alert('메시지가 성공적으로 발송되었습니다.');
        setShowMessageModal(false);
        loadMessageHistory(); // 메시지 이력 새로고침
      } else {
        alert('메시지 발송에 실패했습니다: ' + response.error);
      }
    } catch (error) {
      console.error('메시지 발송 실패:', error);
      alert('메시지 발송에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // 메시지 이력 로드
  const loadMessageHistory = async () => {
    try {
      const response = await api.get('/vacancy/message-history');
      if (response.success) {
        setMessageHistory(response.data);
      }
    } catch (error) {
      console.error('메시지 이력 로드 실패:', error);
    }
  };

  const expiryResponseBadgeClass = (unit) => {
    if (unit.expiry_response_type === 'RENEWAL_INTEREST') return 'bg-blue-100 text-blue-800';
    if (unit.expiry_response_type === 'MOVE_OUT_INTENT') return 'bg-orange-100 text-orange-800';
    return 'bg-gray-100 text-gray-700';
  };

  const formatExpiryRespondedAt = (value) => {
    if (!value) return '';
    return String(value).slice(0, 10);
  };

  const FilterSection = () => {
    console.log('🔍 FilterSection 렌더링:');
    console.log('  - currentUser:', currentUser);
    console.log('  - propertyOwners:', propertyOwners);
    console.log('  - propertyOwners 길이:', propertyOwners?.length);
    
    return (
      <div className="bg-white rounded-lg shadow p-3 sm:p-4 mb-5 sm:mb-6">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          {/* 임대사업자 필터 (RMC 사용자용) */}
          {(currentUser?.role === 'rental_management_company' || 
            currentUser?.role === 'rmc_admin' || 
            currentUser?.role === 'rmc_staff') && (
            <div className="flex w-full items-center gap-2">
              <Home className="h-4 w-4 flex-shrink-0 text-gray-400" />
              <label className="w-20 flex-shrink-0 whitespace-nowrap text-sm font-medium text-gray-700 sm:w-auto">임대사업자:</label>
              <select
                value={selectedPropertyOwner}
                onChange={(e) => handlePropertyOwnerChange(e.target.value)}
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-primary-500"
              >
                <option value="">전체 임대사업자</option>
                {propertyOwners?.map((owner) => (
                  <option key={owner.id} value={owner.id}>
                    {owner.name} ({owner.buildings_count}개 건물)
                  </option>
                ))}
              </select>
            </div>
          )}
          
          {/* 건물 필터 (모든 사용자용) */}
          <div className="flex w-full items-center gap-2">
            <Home className="h-4 w-4 flex-shrink-0 text-gray-400" />
            <label className="w-20 flex-shrink-0 whitespace-nowrap text-sm font-medium text-gray-700 sm:w-auto">건물:</label>
            <select
              value={selectedBuilding}
              onChange={(e) => setSelectedBuilding(e.target.value)}
              className="min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-primary-500"
              disabled={currentUser?.role === 'rental_management_company' && !selectedPropertyOwner}
            >
              <option value="">전체 건물</option>
              {buildings?.map((building) => (
                <option key={building.id} value={building.id}>
                  {building.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  };

  const DashboardTab = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center h-64">
          <div className="text-lg text-gray-600">로딩 중...</div>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        {/* 대시보드 카드들 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Building2 className="h-6 w-6 text-gray-400" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      총 건물 수
                    </dt>
                    <dd className="text-lg font-medium text-gray-900">
                      {dashboardData?.total_buildings || 0}개
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Home className="h-6 w-6 text-gray-400" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      총 세대 수
                    </dt>
                    <dd className="text-lg font-medium text-gray-900">
                      {dashboardData?.total_units || 0}개
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <AlertTriangle className="h-6 w-6 text-red-400" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      공실 수
                    </dt>
                    <dd className="text-lg font-medium text-gray-900">
                      {dashboardData?.vacant_units || 0}개
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="p-5">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <Clock className="h-6 w-6 text-yellow-400" />
                </div>
                <div className="ml-5 w-0 flex-1">
                  <dl>
                    <dt className="text-sm font-medium text-gray-500 truncate">
                      만기예정 계약
                    </dt>
                    <dd className="text-lg font-medium text-gray-900">
                      {dashboardData?.expiring_contracts || 0}건
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 공실 현황 */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">공실 현황</h3>
          </div>
          <div className="p-6">
            {vacantUnits.length === 0 ? (
              <div className="text-center py-8">
                <div className="text-gray-500 text-lg">공실이 없습니다.</div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {vacantUnits.map((unit) => (
                  <div key={unit.id} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="font-medium text-gray-900">{unit.building_name}</h4>
                      <span className="text-sm text-gray-500">{unit.unit_number}</span>
                    </div>
                    <div className="text-sm text-gray-600">
                      <p>면적: {unit.area}㎡</p>
                      <p>월세: {unit.monthly_rent?.toLocaleString()}원</p>
                      <p>보증금: {unit.deposit?.toLocaleString()}원</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* 만기예정 계약 */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">만기예정 계약</h3>
          </div>
          <div className="p-6">
            {expiringUnits.length === 0 ? (
              <div className="text-center py-8">
                <div className="text-gray-500 text-lg">만기예정 계약이 없습니다.</div>
              </div>
            ) : (
              <div className="space-y-4">
                {expiringUnits.map((unit) => (
                  <div key={unit.id} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex justify-between items-start mb-2">
                      <h4 className="font-medium text-gray-900">{unit.building_name} {unit.unit_number}</h4>
                      <span className="text-sm text-red-600 font-medium">
                        {unit.days_until_expiry}일 후 만기
                      </span>
                    </div>
                    <div className="text-sm text-gray-600">
                      <p>임차인: {unit.tenant_name}</p>
                      <p>만기일: {unit.contract_end_date}</p>
                      <p>월세: {unit.monthly_rent?.toLocaleString()}원</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // 공실 세대 탭 컴포넌트
  const VacantUnitsTab = () => (
    <div>
      <FilterSection />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">공실 세대 현황</h3>
        </div>
        <div className="overflow-x-auto">
          {vacantUnits.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">건물명</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">세대호수</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">면적</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">기준월세</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">기준보증금</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">상태</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">액션</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {vacantUnits.map((unit) => (
                  <tr key={unit.unit_id || unit.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.building_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.unit_number}호</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.area}㎡</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.standard_monthly_rent?.toLocaleString() || '-'}원</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.standard_deposit?.toLocaleString() || '-'}원</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                        공실
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleViewDetails(unit)}
                          className="text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          상세보기
                        </button>
                        <button
                          onClick={() => handleSendMessage(unit)}
                          className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          메시지발송
                        </button>
                        <button
                          onClick={() => handleBrokerageRequest(unit)}
                          className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          중개요청
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-6 text-center text-gray-500">
              <p>공실 세대가 없습니다.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // 만기예정 계약 탭 컴포넌트
  const ExpiringUnitsTab = () => (
    <div>
      <FilterSection />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">만기 예정 계약</h3>
        </div>
        <div className="overflow-x-auto">
          {expiringUnits.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">건물/세대</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">임차인</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">만기일</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">남은일수</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">의사상태</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">월세</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">액션</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {expiringUnits.map((unit) => (
                  <tr key={unit.unit_id || unit.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <Building2 className="w-4 h-4 text-gray-400 mr-2" />
                        <div>
                          <div className="text-sm font-medium text-gray-900">{unit.building_name}</div>
                          <div className="text-sm text-gray-500">{unit.unit_number}호</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.tenant_name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.end_date}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        unit.days_until_expiry <= 7 ? 'bg-red-100 text-red-800' :
                        unit.days_until_expiry <= 14 ? 'bg-yellow-100 text-yellow-800' :
                        'bg-green-100 text-green-800'
                      }`}>
                        {unit.days_until_expiry}일
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <span className={'inline-flex px-2 py-1 text-xs font-semibold rounded-full ' + expiryResponseBadgeClass(unit)}>
                        {unit.expiry_response_label || '의사 미확인'}
                      </span>
                      {unit.expiry_responded_at && (
                        <div className="mt-1 text-xs text-gray-500">{formatExpiryRespondedAt(unit.expiry_responded_at)}</div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{unit.monthly_rent?.toLocaleString()}원</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleViewDetails(unit)}
                          className="text-gray-600 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          상세보기
                        </button>
                        <button
                          onClick={() => handleContractRenewalInquiry(unit)}
                          className="text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          계약연장확인요청
                        </button>
                        {unit.expiry_response_type === 'RENEWAL_INTEREST' && (
                          <Link
                            to={'/rmc/contracts/' + unit.contract_id}
                            className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                          >
                            계약 확인
                          </Link>
                        )}
                        {unit.expiry_response_type === 'MOVE_OUT_INTENT' && (
                          <Link
                            to="/rmc/move-in-out"
                            className="text-orange-600 hover:text-orange-900 bg-orange-50 hover:bg-orange-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                          >
                            퇴실 업무
                          </Link>
                        )}
                        <button
                          onClick={() => handleBrokerageRequest(unit)}
                          className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1 rounded-md text-xs font-medium transition-colors"
                        >
                          중개의뢰
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-6 text-center text-gray-500">
              <p>만기 예정 계약이 없습니다.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // 중개요청 내역 탭 컴포넌트
  const HistoryTab = () => (
    <div>
      <FilterSection />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">메시지 발송 이력</h3>
        </div>
        <div className="overflow-x-auto">
          {messageHistory.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">발송일시</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">건물/세대</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">발송방식</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">제목</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">내용</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {messageHistory.map((message) => (
                  <tr key={message.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{message.sent_at}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {message.building_name} {message.unit_number}호
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{message.message_type}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{message.subject}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 max-w-xs truncate">
                      {message.content}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="p-6 text-center text-gray-500">
              <p>발송된 메시지가 없습니다.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* 페이지 제목 */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">공실관리 (RMC 전용)</h1>
        <p className="mt-1 text-sm text-gray-500">
          공실 현황과 만기예정 계약을 관리하세요 - RMC 전용 화면
        </p>
      </div>

      {/* 필터 섹션 */}
      <FilterSection />

      {/* 탭 네비게이션 */}
      <div>
        <nav className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:gap-2" aria-label="공실관리 탭">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`min-h-[44px] rounded-lg border px-3 py-2 text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'border-primary-600 bg-primary-50 text-primary-700 shadow-sm'
                  : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-900'
              }`}
            >
              <span className="break-keep">{tab.label}</span>
            </button>
          ))}
          <Link
            to="/common-modules"
            className="flex min-h-[44px] items-center justify-center rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:border-gray-300 hover:bg-gray-50 hover:text-gray-900"
          >
            <Settings className="mr-1.5 h-4 w-4 flex-shrink-0" />
            <span className="break-keep">공통모듈관리</span>
            <ExternalLink className="ml-1 h-3 w-3 flex-shrink-0" />
          </Link>
        </nav>
      </div>

      {/* 탭 컨텐츠 */}
      <div className="mt-6">
        {activeTab === 'dashboard' && <DashboardTab />}
        {activeTab === 'vacant' && <VacantUnitsTab />}
        {activeTab === 'expiring' && <ExpiringUnitsTab />}
        {activeTab === 'history' && <HistoryTab />}
      </div>

      {/* 메시지 발송 모달 */}
      {showMessageModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">메시지 발송</h3>
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              </div>
              
              {selectedUnit && (
                <div className="mb-4 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-600">
                    <strong>선택된 세대:</strong> {selectedUnit.building_name} {selectedUnit.unit_number}호
                  </p>
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    메시지 템플릿
                  </label>
                  <select
                    value={selectedTemplate}
                    onChange={(e) => handleTemplateSelect(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">템플릿 선택 (선택사항)</option>
                    {messageTemplates.map((template) => (
                      <option key={template.id} value={template.id}>
                        {template.template_name} - {template.category}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    발송 방식
                  </label>
                  <select
                    value={messageForm.message_type}
                    onChange={(e) => setMessageForm({...messageForm, message_type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="email">이메일</option>
                    <option value="sms">SMS</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    제목
                  </label>
                  <input
                    type="text"
                    value={messageForm.subject}
                    onChange={(e) => setMessageForm({...messageForm, subject: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="메시지 제목을 입력하세요"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    내용
                  </label>
                  <textarea
                    value={messageForm.content}
                    onChange={(e) => setMessageForm({...messageForm, content: e.target.value})}
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="메시지 내용을 입력하세요"
                  />
                </div>

                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                      RealtyHub 파트너 선택
                    </label>
                    <span className="text-xs text-gray-500">
                      {(messageForm.partner_ids || []).length}명 선택
                    </span>
                  </div>
                  <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md divide-y divide-gray-100">
                    {partners.length === 0 ? (
                      <div className="p-3 text-sm text-gray-500">
                        등록된 파트너가 없습니다. RealtyHub 파트너 동기화 또는 파트너 등록 후 발송할 수 있습니다.
                      </div>
                    ) : (
                      partners.map((partner) => (
                        <label key={partner.id} className="flex items-start gap-3 p-3 hover:bg-gray-50 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={(messageForm.partner_ids || []).includes(partner.id)}
                            onChange={() => togglePartnerSelection(partner.id)}
                            className="mt-1 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                          />
                          <div className="min-w-0">
                            <div className="text-sm font-medium text-gray-900">
                              {partner.company_name}
                              {partner.agent_name ? ` / ${partner.agent_name}` : ''}
                            </div>
                            <div className="text-xs text-gray-500">
                              {messageForm.message_type === 'email'
                                ? (partner.email || '이메일 없음')
                                : (partner.phone || '전화번호 없음')}
                              {partner.region ? ` · ${partner.region}` : ''}
                              {partner.specialty ? ` · ${partner.specialty}` : ''}
                            </div>
                          </div>
                        </label>
                      ))
                    )}
                  </div>
                </div>              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowMessageModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  취소
                </button>
                <button
                  onClick={sendMessage}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
                  disabled={loading || !(messageForm.partner_ids || []).length}
                >
                  {loading ? '발송 중...' : '발송'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 상세보기 모달 */}
      {showDetailModal && selectedUnit && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-2/3 max-w-4xl shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">세대 상세 정보</h3>
                <button
                  onClick={() => setShowDetailModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h4 className="text-md font-medium text-gray-900 border-b pb-2">기본 정보</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">건물명:</span>
                      <span className="text-sm font-medium">{selectedUnit.building_name}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">세대호수:</span>
                      <span className="text-sm font-medium">{selectedUnit.unit_number}호</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">면적:</span>
                      <span className="text-sm font-medium">{selectedUnit.area}㎡</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">세대유형:</span>
                      <span className="text-sm font-medium">{selectedUnit.unit_type || '-'}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">층수:</span>
                      <span className="text-sm font-medium">{selectedUnit.floor}층</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <h4 className="text-md font-medium text-gray-900 border-b pb-2">임대 정보</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">기준월세:</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_monthly_rent?.toLocaleString() || '-'}원
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">기준보증금:</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_deposit?.toLocaleString() || '-'}원
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">기준관리비:</span>
                      <span className="text-sm font-medium">
                        {selectedUnit.standard_maintenance_fee?.toLocaleString() || '-'}원
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600">상태:</span>
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        selectedUnit.status === 'available' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {selectedUnit.status === 'available' ? '공실' : '임대중'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-4 border-t">
                <div className="flex justify-end space-x-3">
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                  >
                    닫기
                  </button>
                  <button
                    onClick={() => {
                      setShowDetailModal(false);
                      handleSendMessage(selectedUnit);
                    }}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  >
                    메시지 발송
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 중개요청 모달 */}
      {showBrokerageModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">중개요청</h3>
                <button
                  onClick={() => setShowBrokerageModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              </div>
              
              {selectedUnit && (
                <div className="mb-4 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm text-gray-600">
                    <strong>선택된 세대:</strong> {selectedUnit.building_name} {selectedUnit.unit_number}호
                  </p>
                </div>
              )}

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    요청 유형
                  </label>
                  <select
                    value={brokerageForm.request_type}
                    onChange={(e) => setBrokerageForm({...brokerageForm, request_type: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="rental">임대</option>
                    <option value="sale">매매</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    우선순위
                  </label>
                  <select
                    value={brokerageForm.priority}
                    onChange={(e) => setBrokerageForm({...brokerageForm, priority: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="normal">보통</option>
                    <option value="high">높음</option>
                    <option value="urgent">긴급</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    설명
                  </label>
                  <textarea
                    value={brokerageForm.description}
                    onChange={(e) => setBrokerageForm({...brokerageForm, description: e.target.value})}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="중개요청에 대한 설명을 입력하세요"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    연락처
                  </label>
                  <input
                    type="text"
                    value={brokerageForm.contact_person}
                    onChange={(e) => setBrokerageForm({...brokerageForm, contact_person: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-2"
                    placeholder="담당자명"
                  />
                  <input
                    type="tel"
                    value={brokerageForm.contact_phone}
                    onChange={(e) => setBrokerageForm({...brokerageForm, contact_phone: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="연락처"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  onClick={() => setShowBrokerageModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  취소
                </button>
                <button
                  onClick={async () => {
                    if (!selectedUnit) return;
                    
                    try {
                      const monthlyRent = selectedUnit.standard_monthly_rent ? `${selectedUnit.standard_monthly_rent.toLocaleString()}원` : '미정';
                      const deposit = selectedUnit.standard_deposit ? `${selectedUnit.standard_deposit.toLocaleString()}원` : '미정';
                      const maintenanceFee = selectedUnit.standard_maintenance_fee ? `${selectedUnit.standard_maintenance_fee.toLocaleString()}원` : '미정';
                      
                      const requestData = {
                        unit_id: selectedUnit.unit_id || selectedUnit.id,
                        request_type: brokerageForm.request_type,
                        priority: brokerageForm.priority,
                        description: brokerageForm.description || `■ 세대 정보\n- 건물: ${selectedUnit.building_name}\n- 세대: ${selectedUnit.unit_number}호\n- 면적: ${selectedUnit.area || '-'}㎡\n- 기준월세: ${monthlyRent}\n- 기준보증금: ${deposit}\n- 기준관리비: ${maintenanceFee}\n\n${brokerageForm.description}`,
                        contact_person: brokerageForm.contact_person,
                        contact_phone: brokerageForm.contact_phone,
                        notes: brokerageForm.notes
                      };
                      
                      const response = await api.post('/brokerage-service/requests', requestData);
                      
                      if (response.success || response.id) {
                        alert('중개요청이 등록되었습니다.');
                        setShowBrokerageModal(false);
                        setBrokerageForm({
                          request_type: 'rental',
                          priority: 'normal',
                          description: '',
                          expected_rent: '',
                          expected_deposit: '',
                          contact_person: '',
                          contact_phone: '',
                          notes: ''
                        });
                      } else {
                        alert('중개요청 등록에 실패했습니다.');
                      }
                    } catch (error) {
                      console.error('중개요청 등록 실패:', error);
                      alert('중개요청 등록에 실패했습니다.');
                    }
                  }}
                  className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700"
                >
                  등록
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RMCVacancy;
